import {useQuery} from "@tanstack/react-query";
import {listOfferTemplateBindingDefinitionsQueryOptions} from "./list-offer-template-binding-definitions.query-options";

export function useListOfferTemplateBindingDefinitions() {
  return useQuery(listOfferTemplateBindingDefinitionsQueryOptions());
}
